import React from 'react';
import { LabelForm, LabelNormal, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol} from '../componentes_generales/componentes_formulario/contenedores/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import  global_axios  from '../../funciones_globales/interaccionapi';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';

class FormInven16 extends React.Component{
    constructor(props){
        super(props);
            this.state = {
                file: null,
                data_result:[],
                gridOptions: {
                    context: {
                        componentParent: this
                    },

                },
                columnDefs:         [   
                                        {   header: "Fila",
                                            field: "Fila",
                                            width: 50,
                                            type: "string"                                                 
                                        },
                                        {   header: "Articulo",
                                            field: "Articulo",
                                            width: 100,
                                            type: "string"                                                 
                                        },
                                        {   header: "Precio A.C",
                                            field: "PrecioAnt",
                                            width: 100,
                                            type: "num_decimal"                                                 
                                        },
                                        {   header: "Precio D.C",
                                            field: "PrecioDC",
                                            width: 100,
                                            type: "num_decimal"                                             
                                        },
                                        {   header: "Existe Articulo",
                                            field: "ExisteArticulo",
                                            width: 100,
                                            type: "string"                                                
                                        }
                                    ],
            };
            this.onChange = this.onChange.bind(this)
    }

    
    onChange(e) {
        this.setState({file:e.target.files[0]})
    } 

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0216');
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0216');
    }

    fileUpload(file){       
    var data = {};
    const url = '/uploadsCambioPrecioExcel/CambioPrecio';
    const usuario = getItemDatosSesion('usuario').toString();
    const IdRegAudit = this.props.IdRegAudit;

    data.Usuario = usuario;
    data.IdRegAudit = IdRegAudit;
    const formData = new FormData();
    
    formData.append('file',file)
    formData.append('nombreArchivo',file.name)//Willy 20191105
    formData.append('modulo','02')//Willy 20191105
    formData.append('tipo','APA')//Willy 20191105
    formData.append('fecha',new Date())//Willy 20191105
    formData.append('nombre','archivo')
    formData.append('Usuario', usuario)
    formData.append('IdRegAudit', IdRegAudit)
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
        }
        
    }

    return global_axios.post(url,formData,config)
}
           
        


       


    submit(e){
        e.preventDefault()
        if(this.state.file){
            //Proceso para validar que el nombre del archivo no se encuentre ingresado anteriormente.
            //APA=Actualizacion partidas arancelarias
            let query = "?modulo=02&nombreArchivo="+ this.state.file.name +"&tipoTransaccion=APA"
            let config_request_validacion = {
                method: 'GET',
                url: 'validate/getValidacionLoteTransaccion'+query,
            };
            this.props.cambiar_VisualizacionLoading(true); 
            global_axios(config_request_validacion)
            .then((validacion)=>{
                this.props.cambiar_VisualizacionLoading(false);
                if(!validacion.data.encontrado){//Si no fue encontrado el nombre en la tabla log 20191105
                    this.fileUpload(this.state.file)
                    .then((response)=>{
						//console.log('AQUIIIII llega')
						//console.log(response.data.result)
                        this.setState({data_result: response.data.result})
                        alert('Precios Actualizados correctamente, articulos no existentes: '+response.data.errorArticulo); 
                    }).catch((error)=> {
                       // console.log('ERROR: ', error.response)
                        alert(error.response?error.response.data.msg:error.message);
                    });
                }
                else
                {
                    alert('El nombre del excel : '+this.state.file.name + ' ya se encuentra ingresado, por favor correguir para continuar.')
                }
            })
            .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert("No ha seleccionado un archivo");
        }
        
    }

    render(){
        return(
            <ContenedorForm >
                <HeaderForm>
                    <TituloForm> Actualizar Precios por Excel</TituloForm>
                </HeaderForm>
                    <CuerpoForm>
                        <Row>
                            <ContainerCol className='col-md-12'>
                                <LabelForm>Nota:</LabelForm>
                                <LabelNormal>El archivo a subir es un Excel con extención .XLSX. 
                                    Se leerá a partir de la primera fila. El orden debe ser: 
                                    codigo del articulo del sistema, precio nuevo y el Factor el excel no debera contener formulas ni simbolos de moneda.
                                </LabelNormal>
                            </ContainerCol>
                        </Row>
                        <form onSubmit={this.submit.bind(this)}>                            
                        <Row>                         
                            <ContainerCol className='col-md-12'>
                                <LabelForm>Buscar archivo:</LabelForm>
                                <input id='archivo' type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={this.onChange}/>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-md-12'>
                                <br/>
                                <LabelForm>Articulos actualizados:</LabelForm>
                                <AgGridRender altura='300px' data={this.state.data_result} columnas={this.state.columnDefs} gridOptions={this.state.gridOptions}/>                                                           
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-md-12'>
                                <div className="btn-group pull-left">
                                    <LabelCabecera>* La información a subir debe estar en la hoja de calculo con nombre 'PRECIO'</LabelCabecera>
                                </div>
                            </ContainerCol>
                        </Row>    
                        <Row>
                            <div className='col-md-12'>
                                <div className="btn-group pull-right">
                                    <button type="submit" className='btn btn-primary btn-sm'>
                                        <i className="fa fa-refresh "></i> Actualizar
                                    </button>                      
                                </div>
                            </div>                
                        </Row>
                        </form>
                    </CuerpoForm>
            </ContenedorForm>
        );
    }
}

const mapStateToProps = ((state) => {
    return {
     /* fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
      permiso: state.sesion.valoresSesionForm.Permiso,
      IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,*/
    };
});
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({
        generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,cambiar_VisualizacionLoading,
    }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormInven16);

